export const actionTypes = {
  REQUEST_START: 'MESSAGES.MESSAGE_COUNTER.REQUEST_START',
  REQUEST_SUCCESS: 'MESSAGES.MESSAGE_COUNTER.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'MESSAGES.MESSAGE_COUNTER.REQUEST_FAILURE',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
